import { BasesCreate } from './BasesCreate'
import { BasesEdit } from './BasesEdit'
import { BasesList } from './BasesList'
import { BasesShow } from './BasesShow'

export { BasesCreate, BasesEdit, BasesList, BasesShow }
